export class CarrierFilter{
    carrierStatusId: string;
}